import React from 'react';
import { StarIcon } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  age: number;
  quote: string;
  delay?: number;
}
export function TestimonialCard({
  name,
  age,
  quote
}: TestimonialCardProps) {
  return <div className="bg-white p-8 rounded-2xl shadow-sm border border-wellness-beige flex flex-col h-full" data-id="element-51">
      <div className="flex space-x-1 mb-4" data-id="element-52">
        {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-wellness-gold text-wellness-gold" data-id="element-53" />)}
      </div>
      <p className="text-wellness-body italic mb-6 flex-grow" data-id="element-54">"{quote}"</p>
      <div className="flex items-center space-x-4 mt-auto" data-id="element-55">
        <div className="w-12 h-12 bg-wellness-cream rounded-full flex items-center justify-center text-wellness-primary font-bold text-lg border border-wellness-darkBeige" data-id="element-56">
          {name.charAt(0)}
        </div>
        <div data-id="element-57">
          <p className="font-bold text-wellness-dark" data-id="element-58">{name}</p>
          <p className="text-sm text-wellness-body" data-id="element-59">{age} años</p>
        </div>
      </div>
    </div>;
}